import Pqp from "../../../3x1010/Pqp";

export default class Helper {
	static toWeight(w) {
		let s = "" + (w / 10);
		if (s.indexOf(".") < 0) {
			s += ".0"
		}
		return s;
	}

	static toCoin(n) {
		return Pqp.mettiPunti("" + n, ",", ".");
	}

	static toNumber(n) {
		return Pqp.mettiPunti("" + Math.floor(n), ",", ".");
	}

	static toSkill(n, lSign) {
		let s = "" + (n / 10);
		if (s.indexOf(".") < 0) {
			s += ".0"
		}
		if (lSign) {
			if (n < 0) {
				s = "-" + s;
			} else {
				s = "+" + s;
			}
		}

		return s + "%";

	}

	static toFloat(n, lSign) {
		let s = "" + (n / 10);
		if (s.indexOf(".") < 0) {
			s += ".0"
		}
		if (lSign) {
			if (n < 0) {
				s = "-" + s;
			} else {
				s = "+" + s;
			}
		}
		return s;
	}

	static alert(title, text, callback = null,howmany=2) {
		let alertWin = jQuery("#template-confirm").clone();
		alertWin.attr("id", "ale" + Helper.ENUM++);
		jQuery(".js-title", alertWin).html(title);
		jQuery(".js-text", alertWin).html(text);
		jQuery("body").append(alertWin);
		jQuery(".js-yes", alertWin).on("click", Helper.removeAlert.bind(Helper, true, alertWin, callback));
		jQuery(".js-no", alertWin).on("click", Helper.removeAlert.bind(Helper, false, alertWin, callback));
		//console.log("---->"+howmany)
		if (howmany === 1) {
			jQuery(".js-buttons-two", alertWin).hide();
			jQuery(".js-buttons-alt", alertWin).hide();
		} else if (howmany === 2) {
			jQuery(".js-button-single", alertWin).hide();
			jQuery(".js-buttons-alt", alertWin).hide();
		} else if (howmany === 3) {
			jQuery(".js-button-single", alertWin).hide();
			jQuery(".js-buttons-two", alertWin).hide();
		} else {
			jQuery(".js-buttons-two", alertWin).hide();
			jQuery(".js-button-single", alertWin).hide();
			jQuery(".js-buttons-alt", alertWin).hide();
		}
		return alertWin;

	}
	static removeAlert(choice, alertWin, callback) {
		alertWin.remove();
		if (callback) {
			callback.call(null, choice);
		}
	}


	static toArrayObject(csv) {
		let ret = new Array();

		for (let x = 1; x < csv.length; x++) {
			let o = new Object();
			for (let y = 0; y < csv[0].length; y++) {
				o[csv[0][y]] = csv[x][y];
			}
			ret.push(o)
		}
		return ret;
	}

}


Helper.ENUM = 0;